import { render } from "./InfoBlock.vue?vue&type=template&id=f97c0448&scoped=true&ts=true"
import script from "./InfoBlock.vue?vue&type=script&lang=ts"
export * from "./InfoBlock.vue?vue&type=script&lang=ts"

import "./InfoBlock.vue?vue&type=style&index=0&id=f97c0448&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97c0448"]])

export default __exports__